import apiService from './apiService'
import * as _ from 'lodash'
import { HTTP } from './http-common'

var vehiculoService = _.clone(apiService)

vehiculoService.endpoint = '/vehiculo'
vehiculoService.omitUpdate = ['usuarioCreacion', 'propietario', 'group', 'historial']

vehiculoService.saveIcon = function(vehiculoId, icono){
    let url = `${vehiculoService.endpoint}/${vehiculoId}/icono`
    return HTTP.post(url, { icono: icono })
}

export default vehiculoService



// WEBPACK FOOTER //
// ./src/services/vehiculos.js